import { build } from "../../tools/ConfigBuilder";
import { lazy } from "react";

export default build([
	{
		path: "/admin/releases",
		component: lazy(() => import("./AdminReleasesPage")),
	},
]);
